import bonuses from '../assets/bonus/bonuses.png';

export default function ProgressiveBonusGame({ title, text }) {
	return (
		<div className='wrapper'>
			<div className='content'>
				<div className='title'>{title}</div>
				<div style={{ margin: 'auto' }}>{text[0]}</div>
				<br />
				<div className='img_box'>
					<img src={bonuses} alt='' />
				</div>
				<br />
				<div style={{ margin: 'auto' }}>{text[1]}</div>
			</div>
		</div>
	);
}
